import React, {useRef} from 'react'

const PdfViewer = props => {
  const {body, width} = props
  const iframe = useRef()

  return (
    <div style={{ 
      height: 'calc(100vh - 460px)', 
      width: '100%',
      position: 'relative'
    }}>
      <iframe 
        src={body} 
        title="pdf-viewer" 
        width={width || '100%'} 
        height="100%"
        style={{
          border: 'none',
          display: 'block',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }}
        ref={iframe}
      />
    </div>
  )
}

export default PdfViewer